module.exports = __webpack_public_path__ + "static/img/logo-unidas.cce51bae.svg";